import { PeopleTeamRegular } from "@fluentui/react-icons";
import { MessageScreen } from "../components/common";

const WarningPage: React.FC = () => {
  return (
    <MessageScreen
      icon={<PeopleTeamRegular fontSize={36} />}
      title="Uruchom aplikację w Microsoft Teams"
      descriptions={[
        "Aplikacja działa wyłącznie wewnątrz platformy Microsoft Teams i nie może być używana jako samodzielne oprogramowanie.",
        "Otwórz Overtimer z poziomu aplikacji Teams, aby kontynuować.",
      ]}
    />
  );
};

export default WarningPage;
